/* eslint-disable */
import {
  RACButton,
  RACTable,
  RACTableCell,
  RACTableRow,
  RACTooltip,
  Typography,
} from '@rentacenter/racstrap';
import React, { useContext } from 'react';
import i18n from 'i18next'; // Import i18next
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCustomerDetails } from '../../../context/CustomerDetails/CustomerDetailsProvider';
import { abbrev, formatPhoneNumber } from '../../../utils/utils';
import { CustomerLocationState } from '../../../types/types';
import { withContactStyles, WrappedComponentProps } from './withContactStyles';
import { StoreStateContext, useStoreDetails } from '../../../context/Store/StoreProvider';
export const ContactInformationReferencesContent_ = ({
  classes,
  onLogClicked,
}: WrappedComponentProps) => {
  const {
    customerDetails: { personalReferences: data },
    isCommunicationAllowed,
    isRefCommunicationAllowed,
    countryCode,
    isLegalHoldProtected
  } = useCustomerDetails();
  const {enableCountryCode} = useContext(StoreStateContext);
  const location = useLocation<CustomerLocationState>();
  const { t } = useTranslation();

  const renderTableHead = () => (
    <>
      <RACTableCell>{t('Name')}</RACTableCell>
      <RACTableCell>{t('Phone Number')}</RACTableCell>
      <RACTableCell>{t('Relation')}</RACTableCell>
      <RACTableCell>{t('Best Time to Call')}</RACTableCell>
      <RACTableCell>{t('# Contacts Today')}</RACTableCell>
      <RACTableCell>{t('Last Call Result')}</RACTableCell>
      <RACTableCell align="center">{t('Action')}</RACTableCell>
    </>
  );

  const customerId =
    location?.state?.customer?.customerId || location?.pathname?.split('/')[3];
  const { store } = useStoreDetails();
  const storeState = store?.stateAbb?.toUpperCase();
  const countryAbb = store?.countryAbb?.toUpperCase();  
  const regionCode = countryCode.filter((item)=> item.abbreviation == countryAbb)
  const MASSACHUSETTS = 'MA';
  const renderTableContent = () => (
    <React.Fragment>
      {data?.map((dataObj : any) => (
        <RACTableRow
          backgroundColor="white"
          key={
            dataObj.personalReferenceId
              ? `PR${dataObj.personalReferenceId}`
              : `LR${dataObj.landlordReferenceId}`
          }
        >
          <RACTableCell>
            <Typography variant="body2" className={classes.tableContentColor}>
              {dataObj.firstName
                ? `${dataObj.firstName} ${dataObj.lastName || ''}`
                : `${dataObj.landlordFirstName || ''} ${
                    dataObj.landlordLastName || ''
                  }`}
            </Typography>
          </RACTableCell>
          <RACTableCell>
            <Typography variant="body2" className={classes.tableContentColor}>
              {formatPhoneNumber(
                dataObj.phoneNumber,
                dataObj.doNotCall === 'Y' ||
                  isLegalHoldProtected ||
                  !isCommunicationAllowed ||
                  !isRefCommunicationAllowed ||
                  (Number(dataObj.communicationsPerYear) >= 3 &&
                    storeState === MASSACHUSETTS),
                  (enableCountryCode == 1 ? (dataObj.countryCode ? dataObj.countryCode :(regionCode[0]?.countryCodeValue ?? '')): '')
              )}
            </Typography>
          </RACTableCell>
          <RACTableCell>
            <Typography variant="body2" className={classes.tableContentColor}>
              {i18n.t(dataObj.relationshipTypeDesc)}
            </Typography>
          </RACTableCell>
          <RACTableCell>
            <Typography variant="body2" className={classes.tableContentColor}>
              {i18n.t(dataObj.bestTimeToCallDesc)}
            </Typography>
          </RACTableCell>
          <RACTableCell>
            <Typography
              align="center"
              variant="body2"
              className={classes.tableContentColor}
            >
              {dataObj.communicationsToday}
            </Typography>
          </RACTableCell>
          <RACTableCell>
            <Typography noWrap variant="body2" color="primary">
              <RACTooltip
                title={i18n.t(dataObj.lastCallResultDescription || '') || ''}
              >
                <span>
                  {abbrev(i18n.t(dataObj.lastCallResultDescription || ''))}
                </span>
              </RACTooltip>
            </Typography>
          </RACTableCell>
          <RACTableCell align="center">
            <RACButton
              variant="outlined"
              color="primary"
              className={classes.logButton}
              onClick={() =>
                onLogClicked(customerId, dataObj.phoneNumber?.split('.')[0])
              }
              disabled={
                !dataObj?.phoneNumber ||
                !isCommunicationAllowed ||
                isLegalHoldProtected ||
                dataObj.doNotCall === 'Y' ||
                (Number(dataObj?.communicationsPerYear) >= 3 &&
                  storeState === 'MA')
              }
            >
              {t('Log')}
            </RACButton>
          </RACTableCell>
        </RACTableRow>
      ))}
    </React.Fragment>
  );
  return (
    <RACTable
      renderTableHead={renderTableHead}
      renderTableContent={renderTableContent}
    />
  );
};

export const ContactInformationReferencesContent = (props: any) =>
  withContactStyles(props)(ContactInformationReferencesContent_);
